"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmittedCells = void 0;
const react_1 = require("react");
/**
 * Tracks cells that have been submitted (APPLY pressed) but may still be in
 * edit mode while processRowUpdate is pending. Used to suppress the popover
 * auto-opening on scroll-triggered remounts during that window.
 */
const useSubmittedCells = () => {
    const submittedCellsRef = (0, react_1.useRef)(new Set());
    const onCellSubmit = (0, react_1.useCallback)((cellId, fieldName) => {
        submittedCellsRef.current.add(`${cellId}:${fieldName}`);
    }, []);
    const onCellEditStart = (0, react_1.useCallback)((cellId, fieldName) => {
        submittedCellsRef.current.delete(`${cellId}:${fieldName}`);
    }, []);
    const isCellAutoOpen = (0, react_1.useCallback)((cellId, fieldName) => (!submittedCellsRef.current.has(`${cellId}:${fieldName}`)), []);
    return { onCellSubmit, onCellEditStart, isCellAutoOpen };
};
exports.useSubmittedCells = useSubmittedCells;
